<template>
    <div>
        <h2>Wat vond je van deze opdracht?</h2>

        <div class="assignment-feedback" v-for="question in questions" :class="question.name">
            <div class="input-group" v-for="option in question.options">
                <input type="radio" :id="option.tag" :value="option.value" v-model="question.chosen" class="feedback-radio">
                <label :for="option.tag">
                    <span class="feedback-icon" :class="iconClass(option, question)"></span><br>
                    {{ option.text }}
                </label>
            </div>
        </div>

        <textarea class="assignment-feedback" v-model="remarks" placeholder="Op- of aanmerkingen over deze opdracht"></textarea>

    </div>
</template>


<script>
import api from 'js/api/resources'
import { debounceSync } from 'js/vuex/helpers'

export default {
    components: {},
    props: [ 'assignment' ],
    data: function() {
        return {
            remarks: undefined,
            questions: [
                {
                    name: 'enjoyment',
                    options: [
                        {
                            tag: 'fun',
                            text: 'Leuk',
                            value: 10
                        },
                        {
                            tag: 'ok',
                            text: 'Oke',
                            value: 0
                        },
                        {
                            tag: 'stupid',
                            text: 'Stom',
                            value: -10
                        },
                    ],
                    chosen: null,
                },
                {
                    name: 'effort',
                    options: [
                        {
                            tag: 'effortless',
                            text: 'Weinig werk',
                            value: 10
                        },
                        {
                            tag: 'enough',
                            text: 'Genoeg',
                            value: 0
                        },
                        {
                            tag: 'demanding',
                            text: 'Veel werk',
                            value: -10
                        },
                    ],
                    chosen: null,
                },
                {
                    name: 'difficulty',
                    options: [
                        {
                            tag: 'easy',
                            text: 'Makkelijk',
                            value: 10
                        },
                        {
                            tag: 'normal',
                            text: 'Normaal',
                            value: 0
                        },
                        {
                            tag: 'hard',
                            text: 'Moeilijk',
                            value: -10
                        },
                    ],
                    chosen: null,
                },
                {
                    name: 'clarity',
                    options: [
                        {
                            tag: 'clear',
                            text: 'Duidelijk',
                            value: 10
                        },
                        {
                            tag: 'unclear',
                            text: 'Onduidelijk',
                            value: -10
                        },
                    ],
                    chosen: null,
                },
            ]
        }
    },
    methods: {
        saveFeedback: function() {
            var feedback = this.questions.reduce( (sum, el) => {
                sum[el.name] = el.chosen
                return sum
            }, {})
            feedback.remarks = this.remarks
            api.giveFeedback(this.assignment.id, feedback)
        },
        iconClass: function(option, question) {

            var cls = 'icon-'+option.tag
            if ( question.chosen === option.value ) {
                cls += ' active'
            }

            return cls

        }
    },
    created: function() {
        this.debouncedFeedbackSave = debounceSync(this.saveFeedback, 6000, { maxWait: 60000 })
        this.$watch('questions', this.debouncedFeedbackSave, { deep: true})
        this.$watch('remarks', this.debouncedFeedbackSave)
    },
    beforeDestroy: function() {
        this.debouncedFeedbackSave.flush()
    }
}
</script>


<style lang="scss">

    @import 'global';

    .assignment-feedback {
        @include clearfix();

        .input-group {
            float: left;
            padding: 1em 0.6em;
            width: 7em;
            text-align: center;
        }

        @media only screen and (max-width: 700px) {
            .input-group {
                padding: 1em 0.2em;
                width: 4em;
            }
        }

        .input-group, label, .icon {
            cursor: pointer;
            display: block;
        }

        .feedback-radio {
            display: none;
        }

        label {
            line-height: 1.2em;
            &:hover {
                .feedback-icon {
                    transform: translate(0, -5px);
                }
            }
        }

        .feedback-icon {
            display: inline-block;

            transition: transform 0.2s ease-out;

            @include sprite-width($rating-icon-neutral);
            @include sprite-height($rating-icon-neutral);

            @include sprite-image($rating-icon-neutral-2x); // only change this to get retina/non-retina
            @include sprite-background-size($rating-icon-neutral); // always non-retina

            @each $type, $value in $rating-types {
                &.icon-#{$type} {
                    @include sprite-position(nth($value, 1)); // always non-retina

                    &.active {
                        @include sprite-position(nth($value, 2)); // always non-retina
                    }
                }

            }

        }

    }

</style>



// WEBPACK FOOTER //
// AssignmentFeedbackPartial.vue?3ae5c6ed